export default __webpack_public_path__ + "static/media/deny.7d4fca4f.svg";